import { render, staticRenderFns } from "./UserInvitations.vue?vue&type=template&id=2943c47b"
import script from "./UserInvitations.vue?vue&type=script&lang=js"
export * from "./UserInvitations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports